import { defineComponent, getCurrentInstance, useCssModule } from '@nuxtjs/composition-api';
import { useAsyncRef, createHead } from '~/utils';
import { OFFER_PAGE_CONTENT } from '~/pages/franchises/data';
import { useDuck } from '~/services';
import { useModal } from '~/composables';
/**
 * Duck service.
 */
const duck = useDuck();
export default defineComponent({
    name: 'PageFranchiseOffer',
    setup() {
        /**
         * Composables.
         */
        const css = useCssModule();
        const modal = useModal();
        const instance = getCurrentInstance();
        const tariffs = useAsyncRef(instance, 'tariffs');
        function handleModal(tariffId = -1) {
            modal.open('franchiseOffer', {
                componentAttrs: {
                    tariffs: tariffs.value,
                    selectedTariffId: tariffId,
                },
            });
        }
        return {
            css,
            OFFER_PAGE_CONTENT,
            tariffs,
            handleModal,
        };
    },
    async asyncData(context) {
        const { app, env, error, route } = context;
        try {
            const title = 'Предложить франшизу | Forbes Франшизы';
            const { data } = await duck.pub.getPubFranchisesTariffs();
            if (!data?.length) {
                throw new Error('Not found');
            }
            const tariffs = data;
            tariffs.sort((a, b) => {
                if (a.profitable || b.profitable) {
                    if (a.profitable > b.profitable) {
                        return -1;
                    }
                    if (a.profitable < b.profitable) {
                        return 1;
                    }
                }
                if (a.price > b.price) {
                    return -1;
                }
                if (a.price < b.price) {
                    return 1;
                }
                return 0;
            });
            const head = {
                canonical: env.HOST + route.path,
                title,
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            return {
                $page: context.$page,
                head,
                title,
                tariffs,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head);
    },
});
